module.exports = __webpack_public_path__ + "static/media/icon_feather.38d68744.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_feather.svg
// module id = 1874
// module chunks = 0